import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueUserFormJournalController',
            IssueUserFormJournalController
        );

    function IssueUserFormJournalController(
        $state,
        HaEmployeeFactory,
        HousingAssociationsFactory,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.sendUserNote = sendUserNote;
        }

        function sendUserNote() {
            var data = {
                notes: vm.userNote,
                visibility: 2,
            };

            HaEmployeeFactory.readMe().then(function (me) {
                HousingAssociationsFactory.addToJournal(
                    me.data.organization.party_uuid,
                    vm.itemId,
                    data
                ).then(
                    function () {
                        toastr.success('Twoja opinia została dodana');
                        $state.reload();
                    },
                    function () {
                        toastr.error('Nie możesz wysłać pustego formularza');
                    }
                );
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/housing_association_issue_list/journal/journal.controller.ts